import styled from 'styled-components'

export const SwitchLabel = styled.label`
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 15px;
  align-items: start;

  @media (min-width: 1200px) {
    gap: 30px;
    width: 365px;
  }

  .MuiSwitch-thumb {
    background-image: unset;
  }

  & input[type='checkbox'] + span {
    padding-left: unset;
  }
`

export const Texts = styled.span`
  display: inline-flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: bold;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  .info {
    font-weight: normal;
    @media (min-width: 1200px) {
      font-size: 14px;
    }
  }

  .MuiSwitch-thumb {
    background-image: unset;
  }

  & input[type='checkbox'] + span {
    padding-left: unset;
  }
`
